/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMfrmFooterData } from './mfrm-footer.data';
import { IMfrmFooterProps } from './mfrm-footer.props.autogenerated';

export interface IMfrmFooterViewProps extends IMfrmFooterProps<IMfrmFooterData> {}

/**
 *
 * MfrmFooter component
 * @extends {React.PureComponent<IMfrmFooterProps<IMfrmFooterData>>}
 */
class MfrmFooter extends React.PureComponent<IMfrmFooterProps<IMfrmFooterData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MfrmFooter;
